import { render, staticRenderFns } from "./MerchantContactsBlock.vue?vue&type=template&id=55d2868e&"
import script from "./MerchantContactsBlock.vue?vue&type=script&lang=js&"
export * from "./MerchantContactsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports